import FormElementMixin from '@/mixins/form-element-mixin';

export default {
    name: 'QRadio',
    mixins: [FormElementMixin],
    inheritAttrs: false,
    props: {
        options: {
            type: [String, Array, Object],
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        isStacked: {
            type: Boolean,
            default: false
        }
    },
    beforeMount() {
        if (!this.$slots.default && typeof this.options === 'string') {
            this.$slots.default = this.options;
        }
        this.formatItems();
    },
    updated() {
        this.formatItems();
    },
    methods: {
        formatItems() {
            if (typeof this.options === 'string') {
                this.options = [this.options];
            }
        },
        emitValue(event) {
            this.$emit('input', event.target.value);
        }
    }
};
